import { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';

export interface APIBadgesLinkResponse {
  appStoreLink?: string;
  googlePlayLink?: string;
}

export const getBadgesLinks = async (
  flowApi: PlatformControllerFlowAPI,
  metaSiteId: string,
) => {
  const { errorHandler, translations } = flowApi;
  const { t } = translations;
  const { withErrorHandler, getResolvedError } = errorHandler;
  
  try {
    return await withErrorHandler(
      async () => {
        const { data } = await flowApi.httpClient.get<APIBadgesLinkResponse>(
          `/_api/branded-apps/v1/app/public-config`,
          {
            headers: {
              Authorization: flowApi.controllerConfig.appParams.instance,
            },
            // params: {
            //   ids: metaSiteId,
            // },
          },
        );
        return {
          appStoreLink: t('download_my_app.widget.app_store.link.spaces'),
          googlePlayLink: t('download_my_app.widget.google_play.link.spaces'),
          ...data,
        };
      },
      {
        errorCodesMap: {
          applicationError: {
            INVALID_INSTANCE: () => ({
              message: "Invalid app instance provided.",
            }),
            UNAUTHORIZED: () => ({
              message: "You are not authorized to access this resource.",
            }),
            NOT_FOUND: () => ({
              message: "Badge links not found.",
            }),
          },
          serverError: () => ({
            message: t('download_my_app.widget.serverError'),
          }),
        },
      },
    );
  } catch (error) {
    const resolvedError = getResolvedError(error);
    console.error('Error fetching getBadgesLinks:', resolvedError);
    
    // Fallback for any unexpected errors
    return { 
      appStoreLink: '', 
      googlePlayLink: '' 
    };
  }
};
